import { OccasionPageLayout } from '@/components/seo/OccasionPageLayout';
import { getOccasion } from '@/data/occasions';
export default function BirthdayForDad() {
  const o = getOccasion('birthday-for-dad')!;
  return <OccasionPageLayout occasion={o} />;
}
